import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: '¿Cómo funciona?',
    href: '#como-funciona'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-[#1B2B5E] shadow-lg py-3' : 'bg-[#1B2B5E]/90 md:bg-transparent py-5'}`} data-id="element-124">
      <div className="container mx-auto px-4 md:px-6" data-id="element-125">
        <div className="flex items-center justify-between" data-id="element-126">
          <a href="#" className="flex items-center gap-2 z-50" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/dFenca9YduCaDD5NbDBKDV/Imagotipo_-_Las_Palmas.png" alt="Las Palmas Cargo Logistic LLC" className="h-10 md:h-12 object-contain bg-white/90 p-1 rounded" data-id="element-128" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-129">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-[#F5A623] font-medium transition-colors" data-id="element-130">
                {link.name}
              </a>)}
            <a href="https://wa.link/o50a7n" target="_blank" rel="noopener noreferrer" className="bg-[#F5A623] text-[#1B2B5E] px-5 py-2 rounded-lg font-bold hover:bg-white transition-colors" data-id="element-131">
              Cotiza tu envío
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-white z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-132">
            {isMobileMenuOpen ? <X size={28} data-id="element-133" /> : <Menu size={28} data-id="element-134" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`fixed inset-0 bg-[#1B2B5E] z-40 flex flex-col items-center justify-center space-y-8 transition-transform duration-300 md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-135">
        {navLinks.map(link => <a key={link.name} href={link.href} className="text-white text-2xl font-medium hover:text-[#F5A623] transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-136">
            {link.name}
          </a>)}
        <a href="https://wa.link/o50a7n" target="_blank" rel="noopener noreferrer" className="bg-[#F5A623] text-[#1B2B5E] px-8 py-3 rounded-lg font-bold text-xl hover:bg-white transition-colors mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-137">
          Cotiza tu envío
        </a>
      </div>
    </nav>;
}